import { render, staticRenderFns } from "./BanksListItemBack.vue?vue&type=template&id=2b727728&"
import script from "./BanksListItemBack.vue?vue&type=script&lang=js&"
export * from "./BanksListItemBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports